import { TransactionDetails } from 'store/transactions/types';
import { useResolveTransaction } from 'store/transactions/hooks/use-resolve-transaction.hook';

interface UseGetTransactionByIdReturnValues {
  transaction: TransactionDetails | undefined;
  isLoading: boolean;
  isNotFound: boolean;
}

/**
 * RES-999: the routed `/booking-details/:transactionId` page, which is addressed by `details.id`.
 *
 * Now a thin read of the shared resolver (`useResolveTransaction`) rather than its own list scan.
 * Behaviour for an upcoming booking is unchanged -- same match, same `isLoading`/`isNotFound`
 * semantics the page uses to show a placeholder and to bounce rather than hang.
 *
 * What the resolver adds is the hop this page sits on the far side of: a booking opened by uuid at
 * the door is still in the single-transaction slot when this page asks for it by id, so a PAST
 * booking now resolves here instead of opening blank. See the resolver for why that slot survives
 * `openReceipt`.
 */
export const useGetTransactionById = (transactionId: number | string): UseGetTransactionByIdReturnValues =>
  useResolveTransaction({ bookingId: transactionId });
